import request from '@/utils/request';
/* 秒杀活动-商品列表 */
export function queryUserBenefitGoodsPageList(data) {
  return request({
    url: '/user/benefit/goods/queryUserBenefitGoodsPageList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-上架或下架操作 */
export function enableUserBenefitGoodsById(data) {
  return request({
    url: '/user/benefit/goods/enableUserBenefitGoodsById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-查询所有上架的商品列表 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/user/benefit/goods/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-新增操作 */
export function saveUserBenefitGoods(data) {
  return request({
    url: '/user/benefit/goods/saveUserBenefitGoods',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-编辑操作 */
export function updateUserBenefitGoods(data) {
  return request({
    url: '/user/benefit/goods/updateUserBenefitGoods',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-添加商品-编辑时的商品管理明细 */
export function fetchUserBenefitGoodsDetailById(data) {
  return request({
    url: '/user/benefit/goods/fetchUserBenefitGoodsDetailById',
    method: 'POST',
    data
  });
}
/* 秒杀活动-商品列表-删除操作 */
export function removeUserBenefitGoodsById(data) {
  return request({
    url: '/user/benefit/goods/removeUserBenefitGoodsById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/newcomerBenefits.js